// extracted by mini-css-extract-plugin
module.exports = {"carousel-arrow-container":"CarouselArrows_carousel-arrow-container__opjMi","carousel-arrow":"CarouselArrows_carousel-arrow__aSyiY"};